<template>
	<!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单详情
  -->
	<div class="pb50" v-loading="loading">
		<div class="product-content">
			<!--基本信息-->
			<div class="common-form">基本信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="5">
						<div class="pb16">
							<span class="gray9">订单号：</span>
							{{ detail.orderNo }}
						</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5">
						<div class="pb16">
							<span class="gray9">订单状态：</span>
							{{ detail.order_status.text }}
						</div>
					</el-col>
					<el-col :span="5">
						<div class="pb16">
							<span class="gray9">实付款金额 (元)：</span>
							{{ detail.pay_price }}
						</div>
					</el-col>
					<el-col :span="5">
						<div class="pb16">
							<span class="gray9">支付方式：</span>
							{{ detail.pay_type.text }}
						</div>
					</el-col>
					<el-col :span="5">
						<div class="pb16">
							<span class="gray9">下单时间：</span>
							{{ detail.createTime }}
						</div>
					</el-col>				
				</el-row>
			</div>
			<div class="table-wrap">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="订单信息" name="order"></el-tab-pane>
					<el-tab-pane label="项目信息" name="project"></el-tab-pane>
					<el-tab-pane label="加钟信息" name="bell"></el-tab-pane>
					<el-tab-pane label="订单明细" name="detail"></el-tab-pane>
					<el-tab-pane label="订单记录" name="record"></el-tab-pane>
					<el-tab-pane label="服务信息" name="service"></el-tab-pane>
				</el-tabs>
				<div>
					<Order v-show="activeName=='order'"></Order>
					<Project v-show="activeName=='project'"></Project>
					<Bell v-show="activeName=='bell'"></Bell>
					<Detail v-show="activeName=='detail'"></Detail>
					<Record v-show="activeName=='record'"></Record>
					<Service v-show="activeName=='service'"></Service>
				</div>
			</div>
		</div>
		<div class="common-button-wrapper">
			<el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
			<!--用户取消-->
			<template v-if="detail.pay_status.value == 20 && detail.order_status.value == 21">
				<el-button size="small" type="primary" @click="confirmCancel(1)">审核通过</el-button>
			</template>
			<template v-if="detail.pay_status.value == 20 && detail.order_status.value == 21">
				<el-button size="small" type="primary" @click="confirmCancel(0)">审核拒绝</el-button>
			</template>
		</div>
	</div>
</template>

<script>
	import OrderApi from '@/api/order.js';
	import Bell from '@/components/part/bell.vue'
	import Order from '@/components/part/order.vue'
	import Detail from '@/components/part/detail.vue'
	import Project from '@/components/part/project.vue'
	import Record from '@/components/part/record.vue'
	import Service from '@/components/part/service.vue'	
	import {
		deepClone,
	} from '@/utils/base.js';
	export default {
		components: {
			Bell,
			Order,
			Detail,
			Project,
			Record,
			Service
		},
		data() {
			return {
				// 技师是否显示
				isModify: false,
				active: 0,
				activeName:'order',
				/*是否加载完成*/
				loading: true,
				/*订单数据*/
				detail: {
					pay_status: [],
					pay_type: [],
					delivery_type: [],
					user: {},
					address: [],
					product: [],
					order_status: [],
					extract: [],
					extract_store: [],
					express: [],
					delivery_status: [],
					extractClerk: []
				},
				/*是否打开添加弹窗*/
				open_add: false,
				/*一页多少条*/
				pageSize: 20,
				/*一共多少条数据*/
				totalDataNumber: 0,
				/*当前是第几页*/
				curPage: 1,
				/*发货*/
				form: {
					/*订单ID*/
					express_id: null,
					/*订单号*/
					express_no: ''
				},
				forms: {
					is_cancel: 1
				},
				extract_form: {
					order: {
						extract_status: 1
					}
				},
				order: {},
				delivery_type: 0,
				/*配送方式*/
				exStyle: [],
				/*门店列表*/
				shopList: [],
				/*当前编辑的对象*/
				userModel: {},
				/*时间*/
				createTime: '',
				/*快递公司列表*/
				expressList: [],
				shopClerkList: [],
				/*是否打开编辑弹窗*/
				open_edit: false,
				isChange: false,
				addressData: {
					name: '',
					phone: '',
					region: {
						province: '',
						province_id: 0,
						city: '',
						city_id: 0,
						region: '',
						region_id: 0,
						detail: '',
						username: '',
					},
				},
				uses:'',
				user_id:'',
				
			}
		},
		created(e) {
			console.log(e,'user_id')
			/*获取列表*/
			this.getParams();
		},
		methods: {
			modifys(){
				console.log(this.$route.query.orderId,'修改技师')
				// this.$router.push('/order/order/some');
				this.$router.push({
				  path: '/order/order/some',
				  query: {
				    orderId: this.$route.query.orderId,
					user_id:this.user_id
				  }
				});
			},
			// modify() {
			// 	this.isModify = true;
			// 	console.log('展示页面', this.isModify)
			// 	this.$refs.modify.uses = this.uses
			// 	this.$refs.modify.user_id = this.user_id
			// 	this.$refs.modify.user_ids = this.$route.query.orderId;
			// },
			// close(e) {
			// 	let self = this;
			// 	self.isModify = e.openDialog
			// },
			next() {
				if (this.active++ > 4) this.active = 0;
			},
			/*获取参数*/
			getParams() {
				let self = this;
				// 取到路由带过来的参数
				const params = this.$route.query.orderId;
				OrderApi.orderdetail({
							orderId: params
						},
						true
					)
					.then(data => {
						console.log(data)
						self.loading = false;
						self.detail = data.data.detail;
						self.expressList = data.data.expressList;
						self.shopClerkList = data.data.shopClerkList;
						self.addressData = self.detail.address;
						// self.username = self.detail.username
						self.user_id = self.detail.waiter_user_id
						self.uses = self.detail.username
					})
					.catch(error => {
						self.loading = false;
					});
			},
			/*确认取消*/
			confirmCancel(e) {
				let self = this;
				let orderId = this.$route.query.orderId;
				let is_cancel = e;
				OrderApi.confirm({
							orderId: orderId,
							is_cancel: is_cancel
						},
						true
					)
					.then(data => {
						self.loading = false;
						self.$message({
							message: '恭喜你，审核成功',
							type: 'success'
						});
						self.getParams();
					})
					.catch(error => {
						self.loading = false;
					});
			},
			/*取消*/
			cancelFunc() {
				this.$router.back(-1);
			},
			changeAdd() {
				this.isChange = true;
			},
			closeAddress(e) {
				let self = this;
				if (e == false) {
					self.isChange = false;
					console.log(e)
					return false
				}
				let params = e.params;
				console.log(params)
				params.orderId = self.$route.query.orderId
				OrderApi.updateAddress(params,
						true
					)
					.then(data => {
						self.$message({
							message: '修改成功',
							type: 'success'
						});
					})
					.catch(error => {

					});
				self.isChange = false;
			}

		}
	};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/platerefund/detail.vue